module.exports = __webpack_public_path__ + "static/media/lowvolt.4d952677.svg";